import React from 'react';

type IconProps = React.SVGProps<SVGSVGElement>;

const StableIcon: React.FC<IconProps> = (props) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor" {...props} xmlns="http://www.w3.org/2000/svg">
<path d="M11.5 2C10.0413 2 8.64236 2.57946 7.61091 3.61091C6.57946 4.64236 6 6.04131 6 7.5C6 8.95869 6.57946 10.3576 7.61091 11.3891C8.64236 12.4205 10.0413 13 11.5 13C12.9587 13 14.3576 12.4205 15.3891 11.3891C16.4205 10.3576 17 8.95869 17 7.5C17 6.04131 16.4205 4.64236 15.3891 3.61091C14.3576 2.57946 12.9587 2 11.5 2ZM23.657 15.09L16.585 22.161L12.343 17.918L13.757 16.504L16.585 19.333L22.242 13.676L23.657 15.09Z" fill="currentColor"/>
<path d="M12.876 14C11.9821 15.1415 11.4975 16.5502 11.5 18C11.5 19.509 12.014 20.897 12.876 22H2V20C2 18.4087 2.63214 16.8826 3.75736 15.7574C4.88258 14.6321 6.4087 14 8 14H12.876Z" fill="currentColor"/>
</svg>




);

export default StableIcon;


